import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik, FieldArray } from "formik";
import { TbLoader, TbMoneybag } from "react-icons/tb";
import { NumericFormat, PatternFormat } from 'react-number-format';
import * as Yup from "yup";

import { createUserAgencia, 
        getOneUserAgencia, 
        editOneUserAgencia 
      } from "../../../../helpers/Api";
import { CampoSelect } from "../../../../helpers/CampoSelect";
import MyTextArea from "../../../../helpers/MyTextArea";
import TipoNaviera from "../../../../helpers/TipoNaviera";
import AgenteStatus from "../../../../helpers/AgenteStatus";
const FormatoDePerfil = () => {
  
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const params = useParams();

  const [dataAgente, setDataAgente] = useState([]);
  const [navierasCollection, setNavierasCollection] = useState([]);

  //Tipo de asociado
  const tipoDeSocio = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
  ];

  useEffect(() => {
    !params.id ? setLoading(false) : getAgenteAduanal();
    navierasSelected();
  }, [])

  useEffect(() => {
    navierasSelected();
  }, [dataAgente])

  
  const getAgenteAduanal = async () => {
    try {
      const response = await getOneUserAgencia(params.id, token);
      if (response) {
        setDataAgente(response);
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false);
    }
  };

  //This function is to patch a naviera's database 5 items version
  //instead the final 7 items naviera's list. This function is called to push this elements to fix database. 
  const preCatchNavierasList = [
    {
      naviera: "GRM",
      habilitado: false,
    },
    {
      naviera: "ETC",
      habilitado: false,
    },
  ]
  
  const navierasSelected = () => {
    let catcher = [];
    dataAgente?.navieras && dataAgente.navieras.forEach((item) => {
      dataAgente.navieras.forEach((value) => {
        if (item.id === value.id) {
          catcher.push({ naviera: item.naviera, habilitado: item.habilitado });
        }
      });
    });
    dataAgente?.navieras?.length === 5 && catcher.push(...preCatchNavierasList);
    setNavierasCollection(catcher);
  };
 

  let initialValues = {
    nombre: dataAgente?.nombre || "",
    patente: dataAgente?.patente ||  "",
    correo: dataAgente?.correo ||"",
    esta_eliminado: dataAgente?.esta_eliminado || false,
    cantidad_solicitudes: dataAgente?.cantidad_solicitudes || 0,
    direccion: dataAgente?.direccion ||"",
    telefono: dataAgente?.telefono || "", 
    fecha_pagares: dataAgente?.fecha_pagares || '',
    fecha_vencimiento: dataAgente?.fecha_vencimiento || '',
    nombre_contacto: dataAgente?.nombre_contacto || "",
    correo_contacto: dataAgente?.correo_contacto || "",
    garantia_texto: dataAgente?.garantia_texto || "",
    garantia: dataAgente?.garantia || "",
    comentarios: dataAgente?.comentarios || "",
    tipo_socio: dataAgente?.tipo_socio ? tipoDeSocio?.map((value) => value.value === dataAgente?.tipo_socio && {value: value.value, label: value.label}) : {value: 'A', label: 'A'},
    estado: dataAgente?.estado ? AgenteStatus?.map((value) => value.value === dataAgente.estado && {value: value.value, label: value.label}) : {value: 'ACT', label: 'Activo'},
    navieras: dataAgente?.navieras ? navierasCollection : [
      { naviera: "CMA", habilitado: false },
      { naviera: "HAP", habilitado: false },
      { naviera: "ONE", habilitado: false },
      { naviera: "AGN", habilitado: false },
      { naviera: "ALT", habilitado: false },
      { naviera: "GRM", habilitado: false },
      { naviera: "ETC", habilitado: false },
    ],
  };


  function parseData(values) {
    return {
      nombre: values.nombre,
      patente: values.patente,
      correo: values.correo,
      esta_eliminado: values.esta_eliminado,
      cantidad_solicitudes: values.cantidad_solicitudes,
      direccion: values.direccion,
      telefono: values.telefono,
      nombre_contacto: values.nombre_contacto,
      correo_contacto: values.correo_contacto,
      garantia: values.garantia,
      garantia_texto: values.garantia_texto,
      fecha_pagares: values.fecha_pagares,
      estado: values.estado.value,
      fecha_vencimiento: values.fecha_vencimiento,
      tipo_socio: values.tipo_socio.value,
      comentarios: values.comentarios,
      navieras: values.navieras,
    };
  }


  const handlerCreateAgente = async (values, resetForm) => {
    try {
      const response = await createUserAgencia(parseData(values), token);
      if (response) {
        Swal.fire("Exito", "El agente aduanal fue creado con éxito", "success");
        resetForm();
        navigate("/");
      }
    } catch (error) {
      Swal.fire("Oops", "Ha surgido un error", "error");
    }
  };

  const handlerUpdateAgente = async (values, resetForm) => {
    try {
      const response = await editOneUserAgencia( params.id, parseData(values), token);
      if (response) {
        Swal.fire("Exito", "El agente aduanal fue creado con éxito", "success");
        resetForm();
        navigate("/");
      }
    } catch (error) {
      Swal.fire("Oops", "Ha surgido un error", "error");
    }
  };

  return (
    <div className="row mb-5">
      <div className="col-12">
      { loading ? (
          <div className="d-flex justify-content-center" style={{marginTop: '9rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
         ) : (
          <>
        <div
          className={
            dataAgente.length === 0 ? "card card_form" : "m-5"
          }
        >
          <div className="row">
          <div className="col-8">
            { dataAgente.length !== 0 ? (
              <>
                <h6>Cédula de Agente Aduanal</h6>
                <p>Información correspondiente al perfil del agente aduanal</p>
              </>
            ) : (
              <>
                <h6>Formato de Alta</h6>
                <p>Ingrese la información que se le requiere en los campos</p>
              </>
            )}
            </div>
          
        <div className="col-3" style={{textAlign: 'center'}}>  
        <div className=
          { 
            dataAgente.estado_deuda === "BAJ" ? "alert alert-secondary"  :
            dataAgente.estado_deuda === "MED" ? "alert alert-warning"  :
            dataAgente.estado_deuda === "ALT" ? "alert mediaAlert"  :
            dataAgente.estado_deuda === "MAL" ? "alert alert-danger"  :
            null 
          }>

          {dataAgente.length !== 0  && 
            <>
            <div className="d-inline-flex">
              <p>Deuda: </p>
                <NumericFormat 
                prefix={"$"} suffix={" USD"}  
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType="text" 
                value={dataAgente.total_deuda} 
                />
          </div>
          <p style={{fontSize: '12px', marginTop:'10px', textAlign: 'center'}}>
          <TbMoneybag size={'18px'} style={{backgroundColor: 'white', borderRadius: '50px' , padding: '2px', marginRight: '8px'}}/> 
          {dataAgente.tipo_socio === "A" &&
            dataAgente.estado_deuda === "BAJ" ? "Deuda menor a $1,000.000 pesos" :
            dataAgente.estado_deuda === "MED" ? "Deuda menor a $1,500.000 pesos"  :
            dataAgente.estado_deuda === "ALT" ? "Deuda menor a $2,000.000 pesos"  :
            dataAgente.estado_deuda === "MAL" ? "Deuda igual o mayor a $2,000.000 pesos"  :
            null
          }
          {dataAgente.tipo_socio === "B" &&
            dataAgente.estado_deuda === "BAJ" ? "Deuda menor a $500.000 pesos" :
            dataAgente.estado_deuda === "MED" ? "Deuda menor a $1,000.000 pesos"  :
            dataAgente.estado_deuda === "ALT" ? "Deuda menor a $1,500.000 pesos"  :
            dataAgente.estado_deuda === "MAL" ? "Deuda igual o mayor a $1,500.000 pesos" :
            null
          }
          </p>
          </>
          }
           </div>          
          </div>
      </div>
          <Formik
            enableReinitialize="true"
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              nombre: Yup.string().required("Campo requerido"),
              patente: Yup.string().required("Campo requerido"),
              direccion: Yup.string().required("Campo requerido"),
              telefono: Yup.string().required("Campo requerido"),
              correo: Yup.string().required("Campo requerido"),
              garantia_texto: Yup.string().required("Campo requerido"),
              nombre_contacto: Yup.string().required("Campo requerido"),
              correo_contacto: Yup.string().required("Campo requerido"),
              garantia: Yup.string().required("Campo requerido"),
              fecha_pagares: Yup.date().required("Campo requerido"),
              fecha_vencimiento: Yup.date().required("Campo requerido"),
            })}
            onSubmit={(values, { resetForm }) => {
              if (dataAgente.length === 0) {
                handlerCreateAgente(values, resetForm);
              } else
                handlerUpdateAgente(values, resetForm)
            }}
          >
            {(props) => (
              <Form>
                <>
                  <div className="row">
                    <div className="col-8"></div>
                    <div className="col-4">
                      <label className="form-label">Situación</label>
                      <CampoSelect
                        name={"estado"}
                        valores={AgenteStatus}
                        onChange={props.setFieldValue}
                        selectedValue={props.values.estado}
                        placeholder="Seleccione el estado del asociado"
                      />
                    </div>
                    <div className="col-8">
                      <label className="form-label">
                        Nombre de la Agencia Aduanal
                      </label>
                      <Field
                        type="text"
                        name="nombre"
                        className="form-control"
                        placeholder="Ingresa el nombre de la agencia"
                      />
                       <ErrorMessage name="nombre" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Patente</label>
                      <Field
                        type="text"
                        name="patente"
                        className="form-control"
                        placeholder="Ingresa los dígitos de la patente"
                      />
                       <ErrorMessage name="patente" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-8">
                      <label className="form-label">Dirección</label>
                      <Field
                        type="text"
                        name="direccion"
                        className="form-control"
                        placeholder="Ingresa el calle, colonia, ciudad, estado y código postal"
                      />
                       <ErrorMessage name="direccion" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Teléfono</label>
                      <PatternFormat 
                        type="text"
                        format="(###) ###-#####"
                        onValueChange={ (value) => props.setFieldValue("telefono", value.value)}
                        className="form-control"
                        placeholder="Ingresa el número telefónico"
                        value={props.values.telefono}
                      />
                       <ErrorMessage name="telefono" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Correo</label>
                      <Field
                        type="text"
                        name="correo"
                        className="form-control"
                        placeholder="Ingresa el correo general de la agencia"
                      />
                       <ErrorMessage name="correo" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">
                        Nombre completo del contacto
                      </label>
                      <Field
                        type="text"
                        name="nombre_contacto"
                        className="form-control"
                        placeholder="Ingresa el nombre y apellido(s) del contacto"
                      />
                       <ErrorMessage name="nombre_contacto" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Correo del contacto</label>
                      <Field
                        type="text"
                        name="correo_contacto"
                        className="form-control"
                        placeholder="Ingresa el correo de la persona encargada"
                      />
                       <ErrorMessage name="correo_contacto" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Garantía</label>
                      <NumericFormat
                        prefix={"$"}
                        suffix={" MXN"}
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        placeholder="$0.0"
                        onValueChange={ (value) => props.setFieldValue("garantia", value.value)}
                        className="form-control"
                        style={{ textAlign: "right" }}
                        name="garantia"
                        value={props.values.garantia}
                      />
                     <ErrorMessage name="garantia" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Monto de la garantía <i style={{color: '#868686'}}>(Cantidad escrita)</i></label>
                      <Field
                        type="text"
                        name="garantia_texto"
                        className="form-control"
                        placeholder="Ingresa la cantidad de la garantía en letra"
                      />
                       <ErrorMessage name="garantia_texto" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Fecha de Pagarés</label>
                      <Field
                        type="date"
                        onChange={(value) => {
                          let fechaSplit = value.target.value.split('-');
                          let addDefaultYear = Number(fechaSplit[0]) + 1;
                          if(value){
                            props.setFieldValue('fecha_pagares', value.target.value)
                            props.setFieldValue('fecha_vencimiento', addDefaultYear + '-' + fechaSplit[1] + '-' + fechaSplit[2])
                          }
                        }}
                        name="fecha_pagares"
                        className="form-control"
                      />
                      <ErrorMessage name="fecha_pagares" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Fecha de vencimiento</label>
                      <Field
                        type="date"
                        onChange={(value) => props.setFieldValue('fecha_vencimiento', value.target.value)}
                        name="fecha_vencimiento"
                        className="form-control"
                      />
                       <ErrorMessage name="fecha_vencimiento" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Tipo de Socio</label>
                      <CampoSelect
                        type="text"
                        name={"tipo_socio"}
                        valores={tipoDeSocio}
                        onChange={props.setFieldValue}
                        selectedValue={props.values.tipo_socio}
                        className="form-control"
                        placeholder="Seleccione el tipo de socio"
                      />
                    </div>
                  </div>
                  <div className="row mt-5 perfil_naviera">
                    <div className="col-12">
                      <h6>Navieras</h6>
                    </div>
                    <p>Seleccione y habilite las navieras para el agente</p>
                    <div className="col-12">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Nombre de Naviera</th>
                            <th scope="col">Acción</th>
                          </tr>
                        </thead>
                        <FieldArray name="navieras">
                          {({ form }) => (
                            <>
                              {TipoNaviera.map((naviera, index) => (
                                <tbody key={index}>
                                  <tr>
                                    <td style={{ paddingTop: "14px" }}>
                                      { naviera.label }
                                    </td>
                                    <td style={{ paddingTop: "14px" }}>
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          name={`navieras.${index}.habilitado`}
                                          checked={props.values?.navieras[index]?.habilitado}
                                          onChange={(e) => {
                                            form.setFieldValue(
                                              `navieras.${index}.habilitado`,
                                              e.target.checked
                                            );
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          style={{
                                            marginTop: 0,
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          <p>Habilitar</p>
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              ))}
                            </>
                          )}
                        </FieldArray>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <label className="form-label">Comentarios</label>
                      <MyTextArea
                        type="text"
                        className="form-control"
                        name="comentarios"
                        rows="10"
                        cols="50"
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-row-reverse cta_solicitud">
                    <button
                      type="submit"
                      className="btn"
                      style={{ backgroundColor: "#1F107D", width: "8rem" }}
                    >
                      Guardar
                    </button>
                  </div>
                </>
              </Form>
            )}
          </Formik>
        </div>
        </>
         )}
      </div>
    </div>
  );
};

export default FormatoDePerfil;
